import { render } from "./Game.vue?vue&type=template&id=a70a095a&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=a70a095a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a70a095a"

export default script